import React from 'react';
import { connect } from 'react-redux';
import { Button, Input } from 'reactstrap';
import NumberRoute from './Numbers/NumberRoute';

const Routing = ({ e911, gateways, selectRoute, handleQuery, queryLrn, isReadOnly }) => {
  const { number, company, assignedTo, type, routeInfo, _id } = e911;

  return (
    <tr>
      <td>{number || ''}</td>
      <td>{company ? company.name || '' : ''}</td>
      <td>{assignedTo ? assignedTo.email : ''}</td>
      <td>{type || ''}</td>
      <td style={{ width: '20%' }}>
        <NumberRoute
          number={e911}
          disabled={isReadOnly}
          onChange={e => {
            if (number.carrier == "inteliquent")
              return selectRoute(_id, { trunk: e.currentTarget.value })
            selectRoute(_id, {
              routeInfo: {
                route: JSON.parse(e.currentTarget.value).route,
                gateway: JSON.parse(e.currentTarget.value).gateway,
              },
            });
          }}
        />
      </td>
      <td>
        <Button color="info" onClick={() => handleQuery(_id)} style={{ marginRight: '20px' }} disabled={isReadOnly}>
          Query Route
        </Button>
        <Button color="primary" onClick={() => queryLrn(e911)}>
          Query LRN
        </Button>
      </td>
    </tr>
  );
};

const mapStateToProps = state => ({
  user: state.AppState.user,
});

export default connect(mapStateToProps)(Routing);
